module.exports = __webpack_public_path__ + "static/media/2_v2-01.ed16600c.png";